import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"

import ModernModal from "shared/components/ModernModal/index"
import Typograph from "components/Typograph"

import styles from "./styles.css"

const CancelModal = ({ t, isOpen, onClose, onCancelSchedule }) => {
  return (
    <ModernModal
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      onConfirm={onCancelSchedule}
      confirmButtonText={t("CONFIRM")}
      cancelButtonText={t("MSG_0056")}
    >
      <Typograph htmlTag="h2" preset="h2" color="outer_space">
        {t("MSG_0064")}
      </Typograph>
      <Typograph
        htmlTag="p"
        size="medium"
        weight="regular"
        color="outer_space"
        classNames={styles.confirmText}
        dangerouslySetInnerHTML={{ __html: t("CONFIRM_CANCEL_SCHEDULE") }}
      />
    </ModernModal>
  )
}

CancelModal.propTypes = {
  t: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCancelSchedule: PropTypes.func
}

const enhance = compose(translate())

export default enhance(CancelModal)



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/CancelScheduleModal/index.js